<aside
  class="bd-chat-history flex h-full min-h-0 flex-col"
  data-id="assistant-chat-history-panel"
  *transloco="let t; scope: 'featureAiAssistant'; prefix: 'featureAiAssistant'"
  [attr.aria-label]="t('history.title')"
>
  <div class="bd-chat-history-controls">
    <span class="bd-overline">{{ t('history.recents') }}</span>
    <div
      class="bd-chat-history-actions"
      data-id="assistant-chat-history-actions"
    >
      @if (hasFrameContext()) {
        <button
          type="button"
          class="bd-chat-history-tool-button"
          data-id="assistant-chat-history-filter-toggle"
          aria-haspopup="menu"
          [attr.aria-expanded]="filterMenuVisible()"
          [class.bd-chat-history-tool-button-active]="filterMenuVisible()"
          [disabled]="controlsDisabled()"
          [attr.aria-label]="t('history.filterLabel')"
          (click)="filterMenu.toggle($event)"
        >
          <i class="ui-filter" aria-hidden="true"></i>
        </button>
        <p-menu
          #filterMenu
          data-id="assistant-chat-history-filter-menu"
          [model]="filterMenuItems()"
          [popup]="true"
          appendTo="body"
          styleClass="bd-chat-history-menu"
          (onShow)="filterMenuVisible.set(true)"
          (onHide)="filterMenuVisible.set(false)"
        >
          <ng-template #item let-item>
            <span class="bd-chat-history-menu-item">
              <span class="bd-chat-history-menu-item-icon">
                @if (item.icon) {
                  <i [class]="item.icon" aria-hidden="true"></i>
                }
              </span>
              <span class="bd-chat-history-menu-item-label">{{
                item.label
              }}</span>
            </span>
          </ng-template>
        </p-menu>
      }
      <button
        type="button"
        class="bd-chat-history-tool-button"
        data-id="assistant-chat-history-sort-toggle"
        aria-haspopup="menu"
        [attr.aria-expanded]="sortMenuVisible()"
        [class.bd-chat-history-tool-button-active]="sortMenuVisible()"
        [disabled]="controlsDisabled()"
        [attr.aria-label]="t('history.sortLabel')"
        (click)="sortMenu.toggle($event)"
      >
        <i class="ui-sorting-down" aria-hidden="true"></i>
      </button>
      <p-menu
        #sortMenu
        data-id="assistant-chat-history-sort-menu"
        [model]="sortMenuItems()"
        [popup]="true"
        appendTo="body"
        styleClass="bd-chat-history-menu"
        (onShow)="sortMenuVisible.set(true)"
        (onHide)="sortMenuVisible.set(false)"
      >
        <ng-template #item let-item>
          <span class="bd-chat-history-menu-item">
            <span class="bd-chat-history-menu-item-icon">
              @if (item.icon) {
                <i [class]="item.icon" aria-hidden="true"></i>
              }
            </span>
            <span class="bd-chat-history-menu-item-label">{{
              item.label
            }}</span>
          </span>
        </ng-template>
      </p-menu>
      <button
        type="button"
        class="bd-chat-history-tool-button"
        data-id="assistant-chat-history-search-toggle"
        [class.bd-chat-history-tool-button-active]="searchVisible()"
        [disabled]="controlsDisabled()"
        [attr.aria-label]="t('history.searchLabel')"
        [attr.aria-pressed]="searchVisible()"
        (click)="toggleSearch()"
      >
        <i class="ui-search" aria-hidden="true"></i>
      </button>
    </div>
    @if (searchVisible()) {
      <div class="bd-chat-history-search">
        <label class="sr-only" for="assistant-chat-history-search-input">
          {{ t('history.searchLabel') }}
        </label>
        <input
          id="assistant-chat-history-search-input"
          pInputText
          type="text"
          class="bd-chat-history-search-input"
          data-id="assistant-chat-history-search-input"
          [attr.aria-label]="t('history.searchLabel')"
          [disabled]="controlsDisabled()"
          [value]="searchTermDraft()"
          [placeholder]="t('history.searchPlaceholder')"
          (input)="onSearchTermInput($event)"
        />
        @if (hasSearchTermDraft()) {
          <button
            type="button"
            class="bd-chat-history-search-clear-button"
            data-id="assistant-chat-history-search-clear"
            [disabled]="controlsDisabled()"
            [attr.aria-label]="t('history.clearSearchLabel')"
            (click)="clearSearch()"
          >
            <i class="ui-close" aria-hidden="true"></i>
          </button>
        }
      </div>
    }
  </div>
  <div class="bd-chat-history-list bd-small-scrollbar">
    @if (status() === 'loading' && sessions().length === 0) {
      <div
        class="bd-chat-history-state bd-body-regular"
        data-id="assistant-chat-history-loading"
      >
        <i class="ui-loading" aria-hidden="true"></i>
        {{ t('history.loading') }}
      </div>
    } @else if (status() === 'error') {
      <p
        class="bd-chat-history-state bd-body-regular"
        data-id="assistant-chat-history-error"
      >
        {{ t('history.error') }}
      </p>
    } @else if (
      sessions().length === 0 && searchVisible() && hasSearchTermDraft()
    ) {
      <p
        class="bd-chat-history-state bd-body-regular"
        data-id="assistant-chat-history-no-results"
      >
        {{ t('history.noResults') }}
      </p>
    } @else if (sessions().length === 0) {
      <p
        class="bd-chat-history-state bd-body-regular"
        data-id="assistant-chat-history-empty"
      >
        {{ t('history.empty') }}
      </p>
    }

    @for (session of sessions(); track session.deliverableId) {
      <div
        class="bd-chat-history-session"
        data-id="assistant-chat-history-session"
        [class.bd-chat-history-session-active]="
          session.deliverableId === activeSessionId()
        "
        [attr.aria-busy]="isSessionPending(session.deliverableId)"
      >
        @if (editingSessionId() === session.deliverableId) {
          <div
            #renameEditor
            class="bd-chat-history-rename"
            data-id="assistant-chat-history-rename-editor"
          >
            <label class="sr-only" [for]="'chat-session-name-' + $index">
              {{ t('history.renameSessionLabel') }}
            </label>
            <input
              #renameInput
              pInputText
              type="text"
              class="bd-chat-history-rename-input"
              data-id="assistant-chat-history-rename-input"
              [id]="'chat-session-name-' + $index"
              [value]="renameDraft()"
              [attr.aria-invalid]="renameInvalid()"
              [attr.aria-label]="t('history.renameSessionLabel')"
              (input)="onRenameInput($event)"
              (keydown.enter)="submitRename($event)"
            />
            @if (renameDraft().length > 0) {
              <button
                type="button"
                class="bd-chat-history-rename-clear-button"
                data-id="assistant-chat-history-rename-clear"
                [attr.aria-label]="t('history.clearRenameLabel')"
                (mousedown)="$event.preventDefault()"
                (click)="clearRename()"
              >
                <i class="ui-close" aria-hidden="true"></i>
              </button>
            }
          </div>
        } @else {
          <button
            type="button"
            class="bd-chat-history-session-select"
            data-id="assistant-chat-history-session-select"
            [attr.aria-current]="
              session.deliverableId === activeSessionId() ? 'true' : null
            "
            [disabled]="actionsDisabled()"
            (click)="selectSession(session.deliverableId)"
          >
            <span
              class="bd-label-regular bd-chat-history-session-name"
              data-id="assistant-chat-history-session-name"
            >
              @for (part of sessionNameParts(session.name); track $index) {
                @if (part.highlighted) {
                  <strong data-id="assistant-chat-history-session-highlight">{{
                    part.text
                  }}</strong>
                } @else {
                  <ng-container>{{ part.text }}</ng-container>
                }
              }
            </span>
          </button>
          <button
            type="button"
            class="bd-chat-history-session-menu-button"
            data-id="assistant-chat-history-session-menu-toggle"
            [attr.data-session-id]="session.deliverableId"
            [attr.aria-label]="
              t('history.openSessionMenuLabel', { name: session.name })
            "
            aria-haspopup="menu"
            [attr.aria-expanded]="menuSessionId() === session.deliverableId"
            [disabled]="actionsDisabled()"
            (click)="toggleSessionMenu(session.deliverableId, $event)"
          >
            <i class="ui-ellipsis-vertical" aria-hidden="true"></i>
          </button>
        }
        @if (menuSessionId() === session.deliverableId) {
          <div
            class="bd-chat-history-session-menu"
            data-id="assistant-chat-history-session-menu"
            [class.bd-chat-history-session-menu-above]="
              sessionMenuOpensUpward()
            "
            role="menu"
          >
            <button
              type="button"
              class="bd-chat-history-session-menu-item"
              data-id="assistant-chat-history-rename-session"
              role="menuitem"
              [disabled]="actionsDisabled()"
              (click)="startRenaming(session, $event)"
            >
              {{ t('history.renameSessionLabel') }}
            </button>
            <button
              type="button"
              class="bd-chat-history-session-menu-item bd-chat-history-session-menu-delete"
              data-id="assistant-chat-history-delete-session"
              role="menuitem"
              [disabled]="actionsDisabled()"
              (click)="deleteSession(session.deliverableId, $event)"
            >
              <i class="ui-delete" aria-hidden="true"></i>
              {{ t('history.deleteSessionLabel') }}
            </button>
          </div>
        }
        @if (isSessionPending(session.deliverableId)) {
          <i
            class="ui-loading bd-chat-history-session-spinner"
            data-id="assistant-chat-history-session-pending-indicator"
            aria-hidden="true"
          ></i>
        }
      </div>
    }
    @if (hasMore() && status() !== 'error') {
      <div class="bd-chat-history-load-more">
        <button
          type="button"
          class="bd-chat-history-load-more-button bd-label-regular"
          data-id="assistant-chat-history-load-more"
          [disabled]="actionsDisabled() || loadingMore()"
          (click)="loadMore()"
        >
          @if (loadingMore()) {
            <i class="ui-loading" aria-hidden="true"></i>
            {{ t('history.loadingMore') }}
          } @else {
            {{ t('history.loadMore') }}
          }
        </button>
      </div>
    }
  </div>
</aside>
